import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AdminisSharedModule } from './../shared/adminis-shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SelectAccountComponent } from './select-account/select-account.component';
import { SigninComponent } from './signin/signin.component';
import { AuthRoutingModule } from './auth-routing.module';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';

@NgModule({
  declarations: [
    SigninComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    SelectAccountComponent,
    TwoFactorAuthenticationComponent
  ],
  imports: [
    CommonModule,
    AdminisSharedModule,
    ReactiveFormsModule,
    AuthRoutingModule
  ]
})
export class AuthModule { }
